import React, { Component } from 'react'

export class StartPlan extends Component {
    render() {
        return (
            <div className="start-plan">
                <p className="start-plan__text">Start the WholeChild<br />Education Plan</p>
                <a href={this.props.link} className="start-plan__link">START PLAN</a>
            </div>
        )
    }
}

export default StartPlan
